import React, { useContext } from 'react';
import WeekPicker from '../Calendar/WeekPicker';
import '../../styles/sideBar.scss'
import SideMenuSection from '../SideMenuSection';
import { CalendarContext } from '../../context/CalendarContext';
import { AuthContext } from '../../context/AuthContext';
import { format } from 'date-fns';

const Sidebar = ({ children, view = 'calendar', setView }) => {
  const { currentDate } = useContext(CalendarContext);
  const { user, isAdmin, signOut } = useContext(AuthContext);

  const currentMonthName = format(currentDate, 'MMMM');
  return (
    <div className='side-menu-container'>
      <div className='side-menu'>
        <div className="side-menu-top">
          <nav className="side-menu-nav">
            <button
              type="button"
              className={view === 'calendar' ? 'active' : ''}
              onClick={() => setView && setView('calendar')}
            >
              Calendar
            </button>
            {isAdmin && (
              <button
                type="button"
                className={view === 'users' ? 'active' : ''}
                onClick={() => setView && setView('users')}
              >
                Users
              </button>
            )}
            {isAdmin && (
              <button
                type="button"
                className={view === 'consultants' ? 'active' : ''}
                onClick={() => setView && setView('consultants')}
              >
                Consultants
              </button>
            )}
          </nav>
          {view === 'calendar' && (
            <SideMenuSection title={currentMonthName}>
              <WeekPicker />
            </SideMenuSection>
          )}
        </div>
        <div className="side-menu-account">
          {user?.email && <span className="side-menu-email">{user.email}</span>}
          <button className="side-menu-signout" type="button" onClick={signOut}>
            Sign out
          </button>
        </div>
      </div>
      <div className="children-container">
        {children}
      </div>
    </div>
  );
};

export default Sidebar;
